<template>
  <TextInput
    :id="$attrs.id || 'amount'"
    v-bind="$attrs"
    :class="$attrs.class || 'field required'"
    :name="$attrs.name || 'amount'"
    :label="$attrs.label || 'Preço'"
    :placeholder="$attrs.placeholder || 'R$ 1.000,00'"
    :money="true"
    :only-numbers="true"
    maxlength="10"
    :validations="
      $attrs.validations || 'required|greaterThan:0|lowerThan:1000000'
    "
    @blur="$emit('blur')"
    @input="$emit('input', $event)"
  />
</template>
<script>
import TextInput from '@/components/ui/newComponents/TextInput.vue'
export default {
  name: 'AmountInput',
  components: {
    TextInput,
  },
  emits: ['blur', 'input'],
}
</script>
<style lang="scss"></style>
